import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    updateProfile,
    signOut
} from 'firebase/auth';

import { useState, useEffect, useRef } from 'react';

export const useAuthentication = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    //cleanup
    //deal with memory leak
    const cancelled = useRef(false);

    const auth = getAuth();

    function checkIfIsCancelled() {
        return cancelled.current;
    }

    const handleAuthError = (error, fallbackMessage) => {
        const errorCode = error?.code || error?.message || "";

        if (errorCode.includes("weak-password")) {
            return "A senha deve conter pelo menos 6 dígitos.";
        }

        if (errorCode.includes("email-already")) {
            return "Email já cadastrado.";
        }

        if (errorCode.includes("invalid-email")) {
            return "Email inválido.";
        }

        if (
            errorCode.includes("invalid-credential") ||
            errorCode.includes("invalid-login") ||
            errorCode.includes("wrong-password") ||
            errorCode.includes("user-not-found")
        ) {
            return "Email e/ou senha inválidos.";
        }

        if (errorCode.includes("too-many-requests")) {
            return "Muitas tentativas. Aguarde alguns minutos e tente novamente.";
        }

        return fallbackMessage;
    }

    // register
    const createUser = async (data) => {
        if (checkIfIsCancelled()) {
            return { success: false, error: "Operação cancelada." };
        }

        setLoading(true);
        setError(null);

        try {
            const { user } = await createUserWithEmailAndPassword(
                auth,
                data.email,
                data.password
            );

            await updateProfile(user, {
                displayName: data.displayName || data.name || ""
            });

            setLoading(false);

            return { success: true, user };
        } catch (error) {
            const systemErrorMessage = handleAuthError(
                error,
                "Não foi possível criar o usuário. Tente novamente mais tarde."
            );

            setLoading(false);
            setError(systemErrorMessage);

            return { success: false, error: systemErrorMessage };
        }

    }

    // logout
    const logout = () => {
        if (checkIfIsCancelled()) return;

        return signOut(auth)
    }

    // login
    const login = async (data) => {
        
        if (checkIfIsCancelled()) {
            return { success: false, error: "Operação cancelada." };
        }

        setLoading(true)
        setError(null)

        try{

            const { user } = await signInWithEmailAndPassword(auth, data.email, data.password);
            setLoading(false);

            return { success: true, user };
        } catch(error) {
            const systemErrorMessage = handleAuthError(
                error,
                "Não foi possível fazer login. Tente novamente mais tarde."
            );

            setLoading(false);
            setError(systemErrorMessage);

            return { success: false, error: systemErrorMessage };
        }

    }


    useEffect(() => {
        cancelled.current = false;

        return () => {
            cancelled.current = true;
        };
    }, [])

    return {
        auth,
        createUser,
        error,
        loading,
        logout,
        login
    }
}
